import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./PhoneField.css";

/**
 * International phone input with a country flag + dial-code selector.
 * Stores the value as E.164 (+33612345678) — one canonical string in the DB.
 * Default country is France since Julia works in south-west France.
 */
export default function PhoneField({ value, onChange, testId, defaultCountry = "FR" }) {
  return (
    <PhoneInput
      international
      defaultCountry={defaultCountry}
      countryCallingCodeEditable={false}
      value={value || ""}
      onChange={(v) => onChange(v || "")}
      className="julia-phone-input"
      numberInputProps={{
        "data-testid": testId,
        className: "flex-1 h-10 px-3 text-sm bg-white border border-stone-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-stone-900/10 focus:border-stone-400",
      }}
    />
  );
}
